import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import betslip from 'assets/images/slip-illustration.png';
import TextField from '../../common/TextField';
import Button from '../../common/Button';
import { checkBetSlipNumber, checkBetSlipNumberLive } from '../../../modules/validators';
import FormMessage from '../../../containers/FormMessage';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';
import { getMobileNumber } from '../../../modules/account/selectors';
import { logOut } from '../../../modules/auth/actions';
import checkBlocked from '../../../utils/checkBlocked';

const { plusCard } = contentStackImageUrls;

export class AddBetslip extends Component {
  constructor() {
    super();
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      betSlipNumber: '',
      userErrors: [],
      submitDisabled: true,
    };
  }

  componentWillMount() {
    this.props.viewEnter();
  }

  componentWillReceiveProps(nextProps) {
    const { externalErrors } = nextProps;
    if (externalErrors && externalErrors.betSlipNumber) {
      this.setState({
        userErrors: [externalErrors.betSlipNumber],
      });
    } else {
      this.setState({
        userErrors: [],
      });
    }
  }

  handleOnChange(event) {
    const {
      currentTarget: {
        value
      }
    } = event;

    const errors = checkBetSlipNumberLive(value);
    const firstError = errors.length ? [errors[0]] : [];
    const submitDisabled = checkBetSlipNumber(value).length !== 0;

    this.setState({
      betSlipNumber: value,
      userErrors: firstError,
      submitDisabled
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { betSlipNumber } = this.state;
    const { addNewBetslip } = this.props;

    const errors = checkBetSlipNumber(betSlipNumber);
    const isValid = errors.length === 0;
    const firstError = (!isValid) ? [errors[0]] : [];

    this.setState({
      userErrors: firstError
    });

    if (!isValid) {
      return;
    }

    addNewBetslip(
      betSlipNumber
    );
  }

  render() {
    const { userErrors, submitDisabled } = this.state;
    const { addDisabled, mobileNumber, logOutAction } = this.props;
    checkBlocked(mobileNumber, logOutAction);

    return (
      <main className="add-betslip">
        <div className="container--fixed">
          <FormMessage className="add-betslip__form-message" />
          <div className="add-betslip__content">
            <h2 className="add-betslip__header">Manually add your bets</h2>
            <h3 className="add-betslip__lesser-header">Find your case sensitive slip number</h3>
            <img className="add-betslip__betslip-image" src={betslip} role="presentation" />
            <h3 className="add-betslip__lesser-header">… then enter it below</h3>
            <form onSubmit={this.handleSubmit} className="add-betslip__form">
              <TextField
                type="text"
                hintText="e.g. S123456a78b9c12345"
                onChange={this.handleOnChange}
                errors={userErrors}
                maxLength={18}
                disabled={addDisabled}
              />
              <Button
                className="add-betslip__button"
                disabled={addDisabled || submitDisabled}
                onClick={this.handleSubmit}
              >
                Track my bet
              </Button>
            </form>
            <img
              className="add-betslip__card"
              src={plusCard}
              onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
              alt="Plus card"
            />
            <div className="add-betslip__lesser-header">
              Got a Plus card, yet?
            </div>
            <p className="add-betslip__paragraph">
              Pick one up the next time you visit.
              You can use it with our in-store betting points,
              so all of your future bets can be automatically added here.
            </p>
          </div>
        </div>
      </main>
    );
  }
}

AddBetslip.propTypes = {
  externalErrors: PropTypes.object,
  viewEnter: PropTypes.func.isRequired,
  addNewBetslip: PropTypes.func.isRequired,
  addDisabled: PropTypes.bool,
  logOutAction: PropTypes.func,
  mobileNumber: PropTypes.string
};

const mapStateToProps = state => ({
  mobileNumber: getMobileNumber(state)
});

const mapDispatchToProps = {
  logOutAction: logOut
};

export default connect(mapStateToProps, mapDispatchToProps)(AddBetslip);
